import { render, staticRenderFns } from "./awaiting-payment.vue?vue&type=template&id=1f4a66cf"
import script from "./awaiting-payment.vue?vue&type=script&lang=js"
export * from "./awaiting-payment.vue?vue&type=script&lang=js"
import style0 from "./awaiting-payment.vue?vue&type=style&index=0&id=1f4a66cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports